module.exports = __webpack_public_path__ + "media/images/profil_thumb-20ef1de0fa7801546669f4df3411dc1b.png";